import React, { useEffect } from "react";
import ToolBoxTalkAdminList from "../component/toolBoxTalkList/toolBoxTalkAdminList";
import { useDispatch, useSelector } from "react-redux";
import LmsHeader from "../component/lmsHeader/lmsHeader";
import {
  ACCESS_DENIED,
  TOOL_BOX_CREATE,
  TOOL_BOX_LIST,
  TOOL_BOX_DETAIL,
  TOOL_BOX_USERCOUNT_ASSIGN,
  TOOL_BOX_ASSIGN,
} from "../../../constant/routeContant";
import { getPreviousRoute } from "../../../utils/routeTracker";
import { checkPrivileges } from "../../../utils/rolesHelper";
import { PAGE_SIZE, ORG_ID, API_STATUS } from "../../../constant/constant";
import * as toolboxAction from "../../../redux/actions/toolBoxAction";
import * as adminAction from "../../../redux/actions/adminCommonAction";
import Loader from "../../../library/common/Loader";
import { useLocation, useNavigate } from "react-router-dom";

const ToolboxContainer = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const deleteToolBoxTalkData = useSelector((state) => state.deleteToolBoxTalk);
  const deleteStatus = deleteToolBoxTalkData?.status;
  const backTabId = location?.state?.backTabId;
  const tabId = location?.state?.routeProps?.tabId;
  const deleteScheduleToolBoxTalkData = useSelector(
    (state) => state.deleteScheduleToolBoxTalk,
  );

  const deleteScheduleToolBoxTalkStatus = deleteScheduleToolBoxTalkData?.status;
  const deleteisloading = deleteScheduleToolBoxTalkData?.isLoading;
  window.history.replaceState({}, document.title);

  const getToolBoxTalkListResult = useSelector(
    (state) => state.getToolBoxTalkList?.data,
  );

  const getAdminToolBoxTalkListData = useSelector(
    (state) => state.getAdminToolBoxTalkList?.data,
  );

  const getfilterObjListData = useSelector(
    (state) => state.getAdminToolBoxTalkList,
  );

  const showLoader = useSelector(
    (state) => state.getAdminToolBoxTalkList?.isLoading,
  );

  const showLoaderSchedule = useSelector(
    (state) => state.getToolBoxTalkList?.isLoading,
  );
  const getDropdownDataKeyValue = useSelector(
    (state) => state.getDropdownDataKeyValue?.data?.toolboxCategories,
  );
  const handleCreateBtnClick = () => {
    const currentTab =
      sessionStorage.getItem("safetyMeetingCurrentTab") ?? "all";
    sessionStorage.setItem("safetyMeetingCreatedTab", currentTab);
  };

  const dataHeader = {
    title: "Safety Meetings",
    btnText: "Create Safety Meeting",
    btnLink: TOOL_BOX_CREATE,
    menu: [],
    onBtnClick: handleCreateBtnClick,
  };
  if (checkPrivileges([12, 90])) {
    dataHeader.btnText = "Create Safety Meeting";
  }
  const defaultData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    userId: 0,
    status: "",
    categoryIds: "",
    tabId: "0",
    isAssigned: "",
  };
  const defaultAdminData = {
    pageNumber: 1,
    pageSize: PAGE_SIZE,
    search: "",
    catIds: "",
    userId: 0,
    status: "",
    categoryIds: "",
  };
  useEffect(() => {
    const shouldPreserveState =
      sessionStorage.getItem("safetyMeetingPreserveState") === "true";
    const createdMeetingTab = sessionStorage.getItem("safetyMeetingCreatedTab");

    // Returning from create page — restore correct tab data
    if (createdMeetingTab) {
      dispatch(toolboxAction.getSafetyMeetingsFilterObj(defaultAdminData));
      getAdminToolBoxTalkList(defaultAdminData);
      if (createdMeetingTab === "scheduled") {
        getToolBoxTalkListData({ ...defaultData, tabId: "0", isAssigned: "" });
      } else if (createdMeetingTab === "past") {
        getToolBoxTalkListData({ ...defaultData, tabId: "1", isAssigned: "" });
      } else {
        getToolBoxTalkListData(defaultData);
      }
      // NOTE: do NOT remove safetyMeetingCreatedTab here — component reads it to set active tab
      return;
    }

    if (backTabId === 0 || (!tabId && backTabId === undefined)) {
      if (shouldPreserveState && getfilterObjListData?.filterObj) {
        getAdminToolBoxTalkList(getfilterObjListData.filterObj);
        sessionStorage.removeItem("safetyMeetingPreserveState");
      } else {
        getAdminToolBoxTalkList(defaultAdminData);
      }
    } else if (backTabId === 1) {
      if (shouldPreserveState && getfilterObjListData?.filterObj) {
        getToolBoxTalkListData(getfilterObjListData.filterObj);
        sessionStorage.removeItem("safetyMeetingPreserveState");
      } else {
        getToolBoxTalkListData({ ...defaultData, tabId: "0", isAssigned: "" });
      }
    } else if (backTabId === 2) {
      if (shouldPreserveState && getfilterObjListData?.filterObj) {
        getToolBoxTalkListData(getfilterObjListData.filterObj);
        sessionStorage.removeItem("safetyMeetingPreserveState");
      } else {
        getToolBoxTalkListData({ ...defaultData, tabId: "1", isAssigned: "" });
      }
    }
  }, []);
  const getToolBoxTalkListData = (data) => {
    dispatch(toolboxAction.clearScheduleDetailToolBoxTalk());
    dispatch(toolboxAction.getToolBoxTalkList(data));
  };

  const getAdminToolBoxTalkList = (data) => {
    dispatch(toolboxAction.getSafetyMeetingsFilterObj(data));
    dispatch(toolboxAction.getAdminToolBoxTalkList(data));
  };

  const getDropdownDataKeyValueData = {
    orgId: ORG_ID(),
    flags: [20],
  };

  useEffect(() => {
    dispatch(adminAction.getDropdownDataKeyValue(getDropdownDataKeyValueData));
  }, []);

  useEffect(() => {
    const allowedRoutes = [
      TOOL_BOX_LIST,
      TOOL_BOX_DETAIL,
      TOOL_BOX_USERCOUNT_ASSIGN,
      TOOL_BOX_ASSIGN,
      TOOL_BOX_CREATE,
    ];
    const currentPathname = location.pathname;

    if (currentPathname === TOOL_BOX_LIST) {
      const previousRoute = getPreviousRoute();

      if (previousRoute && !allowedRoutes.includes(previousRoute)) {
        dispatch(toolboxAction.getSafetyMeetingsFilterObj(defaultAdminData));
        getAdminToolBoxTalkList(defaultAdminData);
        getToolBoxTalkListData(defaultData);
      }
    }
  }, [location.pathname, location.state, dispatch]);

  const deleteAdminToolBoxTalks = (toolboxId) => {
    dispatch(toolboxAction.deleteToolBoxTalk(toolboxId));
  };
  useEffect(() => {
    if (deleteStatus == API_STATUS.SUCCESS) {
      if (getfilterObjListData?.filterObj) {
        getAdminToolBoxTalkList(getfilterObjListData.filterObj);
      } else {
        getAdminToolBoxTalkList({
          pageNumber: 1,
          pageSize: PAGE_SIZE,
          search: "",
          catIds: "",
          userId: 0,
          status: "",
        });
      }
    }
  }, [deleteStatus]);

  useEffect(() => {
    if (deleteScheduleToolBoxTalkStatus == API_STATUS.SUCCESS) {
      getToolBoxTalkListData({
        pageNumber: 1,
        pageSize: PAGE_SIZE,
        search: "",
        catIds: "",
        userId: 0,
        status: "",
        tabId: 0,
      });
    }
  }, [deleteScheduleToolBoxTalkStatus]);

  getToolBoxTalkListResult?.saftyMeetingList.map((Dta, index) => {
    return (Dta["safetyid"] = index + 1);
  });
  const deleteScheduleToolBoxTalk = (data) => {
    dispatch(toolboxAction.deleteScheduleToolBoxTalk(data));
  };

  return (
    <>
      {checkPrivileges([12, 90, 91]) ? (
        <>
          {deleteisloading && <Loader />}
          <div className="toolboxadmin">
            {checkPrivileges([12, 90]) ? (
              <LmsHeader dataHeader={dataHeader} />
            ) : (
              ""
            )}
          </div>

          {checkPrivileges([12, 90, 91]) && (
            <ToolBoxTalkAdminList
              categoryListData={getDropdownDataKeyValue}
              ToolBoxTalkListData={getAdminToolBoxTalkListData} // data
              getToolBoxTalkListAdmin={getAdminToolBoxTalkList} // function
              showLoader={showLoader}
              deleteAdminToolBoxTalks={deleteAdminToolBoxTalks}
              ToolBoxTalkListDataSchedule={getToolBoxTalkListResult} // data for schedule
              getToolBoxTalkList={getToolBoxTalkListData} // function  for schedule
              deleteScheduleToolBoxTalk={deleteScheduleToolBoxTalk}
              showLoaderSchedule={showLoaderSchedule}
              tabId={tabId}
              backTabId={backTabId}
              getfilterObjListDataList={getfilterObjListData}
            />
          )}
        </>
      ) : (
        navigate(ACCESS_DENIED)
      )}
    </>
  );
};

export default ToolboxContainer;
